import {FC} from "react";
import styled from "styled-components";

interface CompletionCounterProps {
  remainingCount: number;
  isAllCompleted?: boolean;
}

const CounterContainer = styled.div`
  font-size: 0.9rem;
  font-weight: 500;
  color: #666;
  padding: 6px 12px;
  border-radius: 12px;
  background-color: #f5f5f5;
  margin-top: 8px;
  text-align: center;
`;

const CompletedLabel = styled.span`
  color: #4CAF50;
  font-weight: bold;
`;

const Counter = styled.span`
  font-weight: bold;
`;

const CompletionCounter: FC<CompletionCounterProps> = ({
  remainingCount, 
  isAllCompleted = false
}) => {
  return (
    <CounterContainer>
      {isAllCompleted ? (
        <CompletedLabel>All colors completed!</CompletedLabel>
      ) : remainingCount === 0 ? (
        <span>Current color: <CompletedLabel>Complete</CompletedLabel></span>
      ) : (
        <span>Current color: <Counter>{remainingCount}</Counter> remaining</span>
      )}
    </CounterContainer>
  );
};

export default CompletionCounter; 